import { render, staticRenderFns } from "./NumShow.vue?vue&type=template&id=17cbb0a0&"
import script from "./NumShow.vue?vue&type=script&lang=js&"
export * from "./NumShow.vue?vue&type=script&lang=js&"
import style0 from "./NumShow.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NumShow.vue"
export default component.exports